import React from 'react';
import PropTypes from 'prop-types';
export const CheckForIcons = ({ error, optional }) => {
  let icon = '';
  if (false === error) {
    icon = <i className={`ico icon-yes`}></i>;
  } else if (true === error) {
    icon = <i className={`ico icon-no`}></i>;
  } else if (!optional) {
    icon = <span className="required">*</span>;
  }
  return (
    <div className={"form-control-feedback"}>
      {icon}
    </div>
  );
};
